export default (authors) => {
  if (!Array.isArray(authors)) {
    return null;
  }
  switch (authors.length) {
    case 0:
      return '';
    case 1:
      return authors[0];
    case 2:
      return authors.join(' and ');
    default:
      return `${authors.slice(0, -1).join(', ')} and ${authors[authors.length - 1]}`;
  }
};
